export const formatDateWithDots = (date: string) => {
  const [year, month, day] = date.substring(0, 10).split('-');
  return `${day}.${month}.${year}.`;
};
